(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["animated-text"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__animatedTextBlockLoaded) return;
    window.__animatedTextBlockLoaded = true;

    function AnimatedTextBlock(el) {
      this.el = el;
      this.wordEl = el.querySelector('[data-word]');
      this.dynamicEl = el.querySelector('.animated-text-block__dynamic');
      this.cursorEl = el.querySelector('.animated-text-block__cursor');

      var words = [];
      try {
        words = JSON.parse(el.dataset.words || '[]');
      } catch (e) {
        words = [];
      }
      // Trim each entry so stray indentation/whitespace in the settings
      // textarea can't sneak extra space into the animated word itself.
      this.words = words
        .map(function (w) { return (w || '').trim(); })
        .filter(function (w) { return w.length; });

      if (!this.wordEl || !this.dynamicEl) return;

      this.animation = el.dataset.animation || 'typewriter';
      this.speed = parseInt(el.dataset.speed, 10) || 80;
      this.pause = parseInt(el.dataset.pause, 10) || 1800;
      this.loop = el.dataset.loop === 'true';
      this.showCursor = el.dataset.cursor === 'true';
      this.index = 0;
      this.timer = null;
      this.resizeTimer = null;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.cursorEl && !(this.showCursor && this.animation === 'typewriter')) {
        this.cursorEl.style.display = 'none';
      }

      // Reserve enough width for the widest word so the animated word
      // never causes the surrounding line to resize/recenter as it
      // cycles — that reflow is what reads as "the whole sentence moves".
      this.stabilizeWidth();

      var self = this;
      window.addEventListener('resize', function () {
        clearTimeout(self.resizeTimer);
        self.resizeTimer = setTimeout(function () { self.stabilizeWidth(); }, 150);
      });

      if (this.words.length < 2) return;
      this.start();
    }

    AnimatedTextBlock.prototype.stabilizeWidth = function () {
      if (!this.words.length) return;
      var measure = document.createElement('span');
      measure.style.position = 'absolute';
      measure.style.visibility = 'hidden';
      measure.style.whiteSpace = 'pre';
      measure.style.left = '-9999px';
      measure.style.top = '0';
      measure.className = this.wordEl.className;
      this.dynamicEl.appendChild(measure);

      var maxWidth = 0;
      for (var i = 0; i < this.words.length; i++) {
        measure.textContent = this.words[i];
        maxWidth = Math.max(maxWidth, measure.offsetWidth);
      }

      this.dynamicEl.removeChild(measure);
      if (maxWidth > 0) {
        this.dynamicEl.style.minWidth = maxWidth + 'px';
      }
    };

    AnimatedTextBlock.prototype.nextIndex = function () {
      var next = this.index + 1;
      if (next >= this.words.length) {
        if (!this.loop) return null;
        next = 0;
      }
      this.index = next;
      return next;
    };

    AnimatedTextBlock.prototype.start = function () {
      if (this.reduceMotion) {
        this.runSimpleCycle();
      } else if (this.animation === 'typewriter') {
        this.runTypewriter();
      } else {
        this.runTransition(this.animation.replace('_', '-'));
      }
    };

    AnimatedTextBlock.prototype.runSimpleCycle = function () {
      var self = this;
      var step = function () {
        var next = self.nextIndex();
        if (next === null) return;
        self.wordEl.textContent = self.words[next];
        self.timer = setTimeout(step, Math.max(self.pause, 1500));
      };
      this.timer = setTimeout(step, Math.max(this.pause, 1500));
    };

    AnimatedTextBlock.prototype.runTransition = function (type) {
      var self = this;
      var step = function () {
        var next = self.nextIndex();
        if (next === null) return;
        self.wordEl.classList.add('is-out-' + type);
        setTimeout(function () {
          self.wordEl.textContent = self.words[next];
          self.wordEl.classList.remove('is-out-' + type);
          self.wordEl.classList.add('is-in-' + type);
          setTimeout(function () {
            self.wordEl.classList.remove('is-in-' + type);
          }, 420);
        }, 320);
        self.timer = setTimeout(step, self.pause + 750);
      };
      this.timer = setTimeout(step, this.pause);
    };

    AnimatedTextBlock.prototype.runTypewriter = function () {
      var self = this;

      var typeWord = function (word, callback) {
        var i = 0;
        var tick = function () {
          if (i <= word.length) {
            self.wordEl.textContent = word.slice(0, i);
            i++;
            self.timer = setTimeout(tick, self.speed);
          } else {
            callback();
          }
        };
        tick();
      };

      var eraseWord = function (callback) {
        var current = self.wordEl.textContent;
        var i = current.length;
        var tick = function () {
          if (i >= 0) {
            self.wordEl.textContent = current.slice(0, i);
            i--;
            self.timer = setTimeout(tick, self.speed / 1.6);
          } else {
            callback();
          }
        };
        tick();
      };

      var cycle = function () {
        var next = self.nextIndex();
        if (next === null) return;
        eraseWord(function () {
          typeWord(self.words[next], function () {
            self.timer = setTimeout(cycle, self.pause);
          });
        });
      };

      this.timer = setTimeout(cycle, this.pause);
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-animated-text]').forEach(function (el) {
        if (el.dataset.atInit) return;
        el.dataset.atInit = 'true';
        new AnimatedTextBlock(el);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    if (document.readyState !== 'loading') init(document);
  })();
  } catch(e) { console.error(e); }
})();

})();
